import { useAppContext } from '../../AppContext';
import bridge from '@vkontakte/vk-bridge';
import { Gallery as GalleryVkUi } from '@vkontakte/vkui/dist/components/Gallery/Gallery';
import PropTypes from 'prop-types';
import ImageViewer from 'react-simple-image-viewer';
import React from 'react';

const ImgsGalleryVk = ({images}) => {
  if (images.length < 1) {
    return (<></>);
  }

  const context = useAppContext();

  const onClickShowImage = (imgIndex) => {
    if (bridge.supports('VKWebAppShowImages')) {
      bridge.send('VKWebAppShowImages', {
        images: images.map((img) => img.src),
        start_index: imgIndex,
      }).catch((error) => context.showError(error));
    }
  }

  return (
    <>
      <GalleryVkUi slideWidth="100%" bullets="light" showArrows={true}>
        {
          images.map((img, imgIndex) => (
            <img
              key={img.id}
              src={img.src}
              alt={img.name}
              onClick={() => onClickShowImage(imgIndex)}
            />
          ))
        }
      </GalleryVkUi>
    </>
  );
}

const ImgsGalleryTelegram = ({images}) => {
  if (images.length < 1) {
    return null;
  }

  const [show, setShow] = React.useState(false);
  const [curItem, setCurItem] = React.useState(0);

  if (images.length < 1) {
    return (<></>);
  }

  return (
    <>
      {
        show && (<ImageViewer
          src={images.map((img) => img.src)}
          currImg={curItem}
          onClose={() => {
            setShow(false);
            setCurItem(0);
          }}
          disableScroll={false}
          backgroundStyle={{
            backgroundColor: 'rgba(0,0,0,0.9)',
            top: 'var(--vkui--size_panel_header_height--regular)',
          }}
          closeOnClickOutside={true}
        />)
      }
      <GalleryVkUi slideWidth="100%" bullets="light" showArrows={true}>
        {
          images.map((img, number) => (
            <img
              key={img.id}
              src={img.src}
              alt={img.name}
              onClick={() => {
                setCurItem(number);
                setShow(true)
              }}
            />
          ))
        }
      </GalleryVkUi>
    </>
  );
}

export const ImgsGallery = (props) => {
  const context = useAppContext();

  if (context.platform === 'vk') {
    return (<ImgsGalleryVk {...props} />);
  }

  return (<ImgsGalleryTelegram {...props} />);
}

const img = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
});

ImgsGallery.propTypes = {
  images: PropTypes.arrayOf(img).isRequired,
};
